import angular from 'angular'

import idToString from './entities/wagon/idToString.filter'
import stringToId from './entities/wagon/stringToId.filter'

import excel from './entities/excel.filter'
import field from './entities/field.filter'
import search from './entities/search.filter'

import orderPosition from './utils/orderPosition.filter'
import orderObjectBy from './utils/orderObjectBy.filter'

import autocomplete from './utils/autocomplete.filter'
import reverse from './utils/reverse.filter'
import trim from './utils/trim.filter'
import { nospace, noSpecialChar, } from './utils/nospace.filter';

const name = 'filters'
angular.module(name, [])
  .filter('idToString', idToString)
  .filter('stringToId', stringToId)
  .filter('excel', excel)
  .filter('field', field)
  .filter('search', search)
  .filter('orderPosition', orderPosition)
  .filter('orderObjectBy', orderObjectBy)
  .filter('reverse', reverse)
  .filter('trim', trim)
  .filter('nospace', nospace)
  .filter('noSpecialChar', noSpecialChar)
  .filter('autocomplete', autocomplete)

export default name



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/services/filters/filters.module.js